import { User, UserManager } from 'oidc-client-ts';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setAuthHeader } from './services/utils/ApiHeaders';
import { storeUser } from './store/identity/AuthSlice';

export type AuthProviderType = {
  userManager: UserManager;
  children: JSX.Element;
};

export const AuthProvider: React.FC<AuthProviderType> = (props) => {
  const { userManager, children } = props;

  const dispatch = useDispatch();

  useEffect(() => {
    const onUserLoaded = (user: User): void => {
      dispatch(storeUser(JSON.stringify(user)));
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('token', user.access_token);
    };

    const onUserUnloaded = (): void => {
      setAuthHeader(null);
    };

    if (userManager) {
      userManager.events.addUserLoaded(onUserLoaded);
      userManager.events.addUserUnloaded(onUserUnloaded);
    }

    return () => {
      if (userManager) {
        userManager.events.removeUserLoaded(onUserLoaded);
        userManager.events.removeUserUnloaded(onUserUnloaded);
      }
    };
  }, [userManager]);

  return React.Children.only(children);
};
